import { useEffect, useState } from 'react'
import { useBurndownChartRepository } from '../../../../services/adaptors/burndownChartRepositoryAdaptor'
import { BurndownChartBasicInformation } from '../../../../domain/value-object/BurndownChart'
import { WbsPivotAggregationDomain } from '../../../../domain/value-object/WbsPivot'

export const useBasicInformation = (
  domain: WbsPivotAggregationDomain | undefined
) => {
  const { getBasicInformation } = useBurndownChartRepository()
  const [basicInformation, setBasicInformation] = useState<
    BurndownChartBasicInformation | undefined
  >()
  useEffect(() => {
    const fn = async () => {
      const response = await getBasicInformation(domain)
      setBasicInformation(response)
    }
    fn()
  }, [domain])
  return {
    basicInformation,
  }
}
